class Testimonials extends HTMLElement {
  constructor() {
    super();

    this.Slide = this.querySelectorAll('.js-testimonials');
    this.Slide.forEach(slide => {
      this.swiperTestimonials = new Swiper(slide, {
        autoHeight: true,
        loop: true,
        navigation: {
          nextEl: ".testimonials__button-next",
          prevEl: ".testimonials__button-prev",
        },
        loop: true,
        slidesPerView: 1.2,
        centeredSlides: false,
        spaceBetween: 12,
        breakpoints: {
          750: {
            slidesPerView: 2.2,
            spaceBetween: 20,
            centeredSlides: true,
          },
          1200: {
            slidesPerView: 4.06,
            spaceBetween: 30,
            centeredSlides: true,
          },
        },
      });
    });
  }
}
customElements.define("testimonial-custom", Testimonials);